import { render, staticRenderFns } from "./MyHubAndTemplatesPage.vue?vue&type=template&id=502e6db7&"
import script from "./MyHubAndTemplatesPage.vue?vue&type=script&lang=js&"
export * from "./MyHubAndTemplatesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports